import { render, staticRenderFns } from "./translates.vue?vue&type=template&id=1ebf30ae&scoped=true&"
import script from "./translates.vue?vue&type=script&lang=js&"
export * from "./translates.vue?vue&type=script&lang=js&"
import style0 from "./translates.vue?vue&type=style&index=0&id=1ebf30ae&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf30ae",
  null
  
)

export default component.exports